export default __webpack_public_path__ + "static/media/logo1.8c8e66cc.png";